import { render, staticRenderFns } from "./anquan.vue?vue&type=template&id=6e95c563&scoped=true&"
import script from "./anquan.vue?vue&type=script&lang=js&"
export * from "./anquan.vue?vue&type=script&lang=js&"
import style0 from "./anquan.vue?vue&type=style&index=0&id=6e95c563&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e95c563",
  null
  
)

export default component.exports